module.exports = __webpack_public_path__ + "img/comfortIcon.f47de7fd.png";